import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import Link from './NavLink';

import {loadJson} from '../../utils/loadjson';
const viStr = loadJson( '/assets/vi.json');
const enStr = loadJson( '/assets/en.json');


const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 24px 0;
  align-items: center;
`;

const InfoWrap = styled.div`
  margin-left: 24px;
`;

const TenTruong = styled.p`
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  color: #062A56;
  letter-spacing: 0.5px;
  text-shadow: 1px 2px 3px #CCCCCC;
  line-height: 1.2;
  margin: 0;
`;

const TenKhoa = styled(TenTruong)`
  color: #FB5422;
  font-size: 32px;
  font-weight: 700;
  margin-top: 10px;
  font-family: 'Open Sans', sans-serif;
`;

const KhauHieu = styled.p`
  font-size: 15px;
  color: #AB1015;
  letter-spacing: 1px;
  line-height: 1;
  margin: 0;
  margin-top: 10px;
`;

const HeaderLogo = (props) => {
  return (
  <Wrapper className="header-logo-wrapper">
    <Link to={props.lang === 'en' ? enStr["HeaderLogo.Url"] : viStr["HeaderLogo.Url"] }>
      <img
        className="ou-logo"
        alt='ou-logo'
        src="/assets/images/ou-logo.png"
        style={{ flex: 1, height: '100px', width: 'auto', objectFit: 'contain' }}
      />
    </Link>
    <InfoWrap className="header-title">
      <TenTruong className='ten-truong only-tablet-min'>
        <FormattedMessage id="HeaderLogo.TenTruongMin" />
      </TenTruong>
      <TenTruong className='ten-truong only-tablet'>
        <FormattedMessage id="HeaderLogo.TenTruong" />
      </TenTruong>
      <TenKhoa className='ten-khoa'>
        <FormattedMessage id="HeaderLogo.TenKhoa" />
      </TenKhoa>
      <KhauHieu className='khau-hieu only-tablet'>
        <FormattedMessage id="HeaderLogo.SloganFull" />
      </KhauHieu>
      <KhauHieu className='khau-hieu only-tablet-min'>
        <FormattedMessage id="HeaderLogo.SloganFirst" />
      </KhauHieu>
      <KhauHieu className='khau-hieu only-tablet-min'>
        <FormattedMessage id="HeaderLogo.SloganSecond" />
      </KhauHieu>
    </InfoWrap>
  </Wrapper>
  );
};

export default HeaderLogo;



// WEBPACK FOOTER //
// ./src/components/layouts/HeaderLogo.js